import { useState } from 'react';
import type { NotificationRecipient } from '@/lib/notificationSend.ts';

export interface PeopleSelection {
  selectedIds: string[];
  selected: NotificationRecipient[];
  allSelected: boolean;
  /** Whose preview staff asked for; otherwise the first one ticked stands for the rest. */
  previewForId: string | null;
  select: (userIds: string[]) => void;
  toggleAll: () => void;
  toggleOne: (userId: string, checked: boolean) => void;
  showPreviewFor: (userId: string) => void;
  clear: () => void;
}

/** Who is ticked off, for a moment that goes to a whole list at once. */
export function usePeopleSelection(people: NotificationRecipient[]): PeopleSelection {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [previewForId, setPreviewForId] = useState<string | null>(null);

  const allSelected = people.length > 0 && selectedIds.length === people.length;

  const toggleAll = () => {
    setSelectedIds(allSelected ? [] : people.map((person) => person.user_id));
  };

  const toggleOne = (userId: string, checked: boolean) => {
    setSelectedIds((current) =>
      checked ? [...current, userId] : current.filter((id) => id !== userId),
    );
  };

  const clear = () => {
    setSelectedIds([]);
    setPreviewForId(null);
  };

  return {
    selectedIds,
    selected: people.filter((person) => selectedIds.includes(person.user_id)),
    allSelected,
    previewForId,
    select: setSelectedIds,
    toggleAll,
    toggleOne,
    showPreviewFor: setPreviewForId,
    clear,
  };
}
